import { AbschnittsdatenFilter } from "./AbschnittsdatenFilter";

export default function Abschnittsdaten({vvInstance, statusInstance, zvInstance, absdInstance}) {
    return (
        <div>
            <h1>Abschnittsdaten</h1>
            <AbschnittsdatenFilter vvInstance={vvInstance} statusInstance={statusInstance} zvInstance={zvInstance} absdInstance={absdInstance}/>
        </div>
    )
}